import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { BottomSheetExpandStates, BottomSheetUiConfig } from '../shared/models/bottom-sheet.types';


@Injectable({
  providedIn: 'root'
})
export class BottomSheetDataService {

  private readonly PERSISTED_BOTTOM_SHEET_EXPANDED_STATE_KEY = "PERSISTED_BOTTOM_SHEET_EXPANDED_STATE_KEY";
  private readonly PERSISTED_BOTTOM_SHEET_UI_CONFIG_KEY = "PERSISTED_BOTTOM_SHEET_UI_CONFIG_KEY";

  public readonly bottomSheetExpandedState: Signal<BottomSheetExpandStates>;
  public readonly bottomSheetUiConfig: Signal<BottomSheetUiConfig>;

  private _expandedStateSignal: WritableSignal<BottomSheetExpandStates>;
  private _uiConfigSignal: WritableSignal<BottomSheetUiConfig>;

  constructor() { 
    // TODO - Remove comment when persistence is needed
    // const persistedBottomSheetState: BottomSheetExpandStates = (localStorage.getItem(this.PERSISTED_BOTTOM_SHEET_EXPANDED_STATE_KEY) as BottomSheetExpandStates) ?? 'hidden';
    // const persistedBottomSheetUiConfig: string | null = localStorage.getItem(this.PERSISTED_BOTTOM_SHEET_UI_CONFIG_KEY);

    const persistedBottomSheetState: BottomSheetExpandStates = 'hidden';
    const persistedBottomSheetUiConfig: string | null = null;

    this._expandedStateSignal = signal<BottomSheetExpandStates>(persistedBottomSheetState);
    this._uiConfigSignal = signal<BottomSheetUiConfig>(persistedBottomSheetUiConfig ? JSON.parse(persistedBottomSheetUiConfig): null);

    this.bottomSheetUiConfig = this._uiConfigSignal.asReadonly();
    this.bottomSheetExpandedState = this._expandedStateSignal.asReadonly();
  }

  setBottomSheetExpandedState(newState: BottomSheetExpandStates) {
    localStorage.setItem(this.PERSISTED_BOTTOM_SHEET_EXPANDED_STATE_KEY, newState);
    this._expandedStateSignal.set(newState);
  }

  setBottomSheetUiConfig(config: BottomSheetUiConfig) {
    localStorage.setItem(this.PERSISTED_BOTTOM_SHEET_UI_CONFIG_KEY, JSON.stringify(config));
    this._uiConfigSignal.set(config);
  }
}
